import { createFileRoute } from "@tanstack/react-router";
import { RouteGuard } from "@/components/RouteGuard";
import { Navigate } from "@/lib/router-compat";

export const Route = createFileRoute("/admin/user-analytics")({
  component: () => (
    <RouteGuard access={{ kind: "admin" }}>
      <Navigate to="/admin/data-analytics" replace />
    </RouteGuard>
  ),
});
